import { render, staticRenderFns } from "./ArrowsUpDown.vue?vue&type=template&id=5bea65ae"
import script from "./ArrowsUpDown.vue?vue&type=script&lang=js"
export * from "./ArrowsUpDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports